import {FreeSpinsModule} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsModule';
import {GameFreeSpinsOutroState} from 'src/freespins/states/GameFreeSpinsOutroState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameFreeSpinsIntroState} from 'src/freespins/states/GameFreeSpinsIntroState';

export class GameFreeSpinsModule extends FreeSpinsModule {

	public restore(): void {
		super.restore();

		if (this.logic.isFreeSpinsStarted) {
			(this.logic as GameRecodeLogic).goIntoFreeSpins();
		}
	}

	protected setupStates(): void {
		super.setupStates();
		this.addState(new GameFreeSpinsOutroState(this, FreeSpinsModule.OUTRO_STATE));
		this.addState(new GameFreeSpinsIntroState(this, FreeSpinsModule.INTRO_STATE));
	}
}



// WEBPACK FOOTER //
// ./src/freespins/GameFreeSpinsModule.ts